import openSocket from 'socket.io-client';

let socket;
export const openConnection = uri => {
    socket = openSocket(uri, {
        path: '/ws',
        transports: ['websocket']
    })
};

export const getSocket = () => socket;